export default __webpack_public_path__ + "static/melted-77e29f5987f3a030c9728898f95ad063.png";